/**
 * Bulk weather-map key. UTC hour disambiguates doubleheaders (typically afternoon
 * + evening, distinct UTC hours). Used by `/api/weather/mlb` to populate the map
 * and by `useMlbWeather` to look entries up — must stay in sync.
 *
 * Pure module (no server-only imports) so it's safe to use from client code.
 */
export function weatherMapKey(homeAbbr: string, gameTimeIso: string): string {
  const d = new Date(gameTimeIso);
  const ymd = `${d.getUTCFullYear()}${String(d.getUTCMonth() + 1).padStart(2, '0')}${String(d.getUTCDate()).padStart(2, '0')}`;
  const hh = String(d.getUTCHours()).padStart(2, '0');
  return `${homeAbbr}_${ymd}_${hh}`;
}
